import { render } from "./TakeYourBusiness.vue?vue&type=template&id=580232d6"
import script from "./TakeYourBusiness.vue?vue&type=script&lang=js"
export * from "./TakeYourBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__